import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavItemComponent } from './sidenav-item.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { IconModule } from '@visurel/iconify-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { JobCreateUpdateModule } from 'src/app/pages/apps/jobs/jobs-listing/job-create-update/job-create-update.module';
import { JobApprovalCreateUpdateModule } from 'src/app/pages/apps/jobs/jobs-approval-listing/job-approval-create-update/job-approval-create-update.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SidenavItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatRippleModule,
    IconModule,
    FlexLayoutModule,
    JobCreateUpdateModule,
    JobApprovalCreateUpdateModule,
    TranslateModule,
  ],
  exports: [SidenavItemComponent],
})
export class SidenavItemModule {}
